import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle, Button, Badge } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import {
  gAPI_Tickets_list,
  gAPI_Tickets_By_Id,
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import notickets from '../../../../../assets/noticket.png';
import ChatListItem from '../../../../../components/chats/ChatListItem';
import 'react-datepicker/dist/react-datepicker.css';
import Masking from '../../../../../data/Masking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';

const StatusOptionMissed = [
  { value: 'Pending', label: 'Assigned' },
  { value: "PendingBusiness", label: "Pending with Business" },
  { value: "PendingBookmebob", label: "Pending with Myma.ai" },
  { value: "AssignBusiness", label: "Assign to Business" },
  { value: "AssignBookmebob", label: "Assign to Myma.ai" }
]
const ArchivedTickets = ({
  startDate,
  endDate,
  offset,
  items,
  isLoading,
  data,
  activeIndex,
  handleContactClick,
  propertyId,
  tagValue,
  statusValue,
  handleLoadMore,
  handleMaskClick,
  isMasked,
  isAgentAssist = false,
  getImage,
  isMissingUrl,
  categoryList
}) => {
  const [tickets, setTickets] = useState(Array.isArray(data) ? data : []);
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(false);
  const [categoryColorList, setCategoryColorList] = useState([]);
  useEffect(() => {
    setTickets(Array.isArray(data) ? data : []);
  }, [data]);

  function generateRandomColorCategory(category) {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
      'orange',
      'blue',
      'violet',
      'light-red',
      'sky-blue',
      'outline-primary',
      'outline-secondary',
      'outline-info',
      'outline-success',
      'outline-warning',
      'outline-danger',
      'outline-light',
      'outline-dark',
    ];
    return arr[category];
  }
  useEffect(() => {
    if (categoryList.length > 0) {
      var colorList = [];
      categoryList.map((elem, i) =>
        colorList.push({ text: elem.value, color: generateRandomColorCategory(i) })
      );
      setCategoryColorList(colorList);
    }
  }, [categoryList]);
  // useEffect(() => {
  //   const urll = window.location.pathname;
  //   const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);
  //   const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
  //   const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
  //   AxiosAPI({
  //     methhod: 'get',
  //     url: `${gAPI_Tickets_list}?gid=${getGroupID()}&pid=${propertyId}&df=${start}&dt=${end}&tags=${tagValue === '' ? '-1' : tagValue}&offset=${0}&limit=${itemsNum}&status=${statusValue == '' ? '-1' : statusValue}&mr=${currentUrlName === 'missingresponse' ? 'yes' : 'no'}`,
  //   }).then((res) => {
  //     setTickets(res.data.tickets);
  //     setLoading(false);
  //   });
  // }, [itemsNum, endDate, startDate]);

  const loadMore = () => {
    handleLoadMore();
    // setItemsNum(itemsNum + 30);
    // setLoading(true);
  };

  const [showButton, setShowButton] = useState(false);
  const handleScroll = (e) => {
    //console.log(e.target.clientHeight)
    //console.log(e.target.scrollHeight - e.target.scrollTop - 10)
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
    if (bottom && Array.isArray(tickets) && tickets.length > 0) {
      setShowButton(true);
    }
  };

  return (
    <div
      className="cardHeightTickets"
      style={{ overflow: 'hidden scroll', scrollbarColor: 'darkgrey white' }}
      onScroll={handleScroll}
    >
      <div>
        <div className="scroll">
          {!isLoading ? (
            <Fragment>
              {Array.isArray(tickets) && tickets.length > 0 ? (
                <Fragment>
                  {tickets.map((chat, index) => {
                    return (
                      // <NavLink
                      //   key={`chat_${index}`}
                      //   to="#"
                      //   className={
                      //     activeIndex === index
                      //       ? 'd-flex selectedchat'
                      //       : 'd-flex'
                      //   }
                      //   onClick={() =>
                      //     handleContactClick(index, chat.id, chat.conversationId)
                      //   }
                      // >
                      //   <div className="d-flex flex-row border-bottom conversation">
                      //     <div className="pl-3 pt-2 pr-2 pb-2 conversation">
                      //       <p className="conversationdate">{moment(chat.creationTime).utc().format("DD/MM/YYYY h:mm a")}</p>

                      //       <div className="pr-4">
                      //         <p className="mb-1 text-small">
                      //           Requester:{" "}
                      //           {chat.requesterEmail}
                      //           <br />
                      //           {chat.status}, {chat.source}
                      //         </p>
                      //       </div>
                      //     </div>
                      //   </div>
                      // </NavLink>

                      <div
                        key={`chat_${index}`}
                        className={
                          activeIndex === index
                            ? 'd-flex flex-row mb-3 selectedchat'
                            : 'd-flex flex-row mb-3'
                        }
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          handleContactClick(
                            index,
                            chat.id,
                            chat.conversationId,
                            chat.isTicket
                          )
                        }
                      >
                        {(isAgentAssist !== undefined && isAgentAssist == true) && <div className="d-block-ticket mx-2" >
                          {getImage(
                            chat.requesterPhoneNumber,
                            chat.source
                          )}

                        </div>}
                        <div className="pl-1 pt-2 pr-2 pb-2">
                          <div className="pr-4">
                            {isMissingUrl ?
                              <Badge color="secondary" pill>
                                {StatusOptionMissed.filter((i) => i.value === chat.status).length > 0 ?
                                  StatusOptionMissed.filter((i) => i.value === chat.status).
                                    map(i => i.label) :
                                  chat.status
                                }
                              </Badge> :
                              chat.tags.map((tag, index) => {
                                return (
                                  <Fragment key={index}>
                                    <Badge key={index} color={categoryColorList.filter(l => l.text === tag).map(x => x.color)} pill>
                                      {tag}
                                    </Badge>
                                  </Fragment>
                                );
                              })}
                          </div>
                          <p className="list-item-heading">
                            {chat.requesterName === ''
                              ? chat.requesterEmail
                              : chat.requesterName}
                          </p>
                          <div className="pr-4">
                            <p className="text-muted mb-1 text-small">
                              {isMasked !== "true" ?
                                <Masking input={chat.requesterPhoneNumber} inputType={"mobile"} number={4}></Masking> : chat.requesterPhoneNumber}
                              {chat.requesterPhoneNumber !== "" && chat.requesterPhoneNumber !== null &&
                                <span className="text-muted ml-1" style={{ cursor: "pointer" }} onClick={() => handleMaskClick()}>
                                  <FontAwesomeIcon icon={isMasked === "true" ? faLock : faLockOpen} className="fa" />
                                </span>}
                            </p>
                            <p className="text-muted mb-1 text-small">
                              {isMasked !== "true" ?
                                <Masking input={chat.requesterEmail} inputType={"email"}></Masking> : chat.requesterEmail}
                              {chat.requesterEmail !== "" && chat.requesterEmail !== null &&
                                <span className="text-muted ml-1" style={{ cursor: "pointer" }} onClick={() => handleMaskClick()}>
                                  <FontAwesomeIcon icon={isMasked === "true" ? faLock : faLockOpen} className="fa" />
                                </span>
                              }
                            </p>
                          </div>
                          <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                            {moment(chat.creationTime).format(
                              'DD/MM/YYYY h:mm a'
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Fragment>
              ) :
                <Fragment>
                  <div className='text-center no-ticket'>
                    {/* <p>No tickets found matching the selection criteria</p> */}
                    <img
                      src={notickets}
                      alt="No Tickets"
                      style={{
                        width: '80%',
                      }}
                    />
                  </div>
                </Fragment>
              }
            </Fragment>
          ) : (
            <div className="loading" />
          )}
        </div>
        {loading && (
          <div
            style={{ textAlign: 'center', fontSize: '16px', margin: '8px 0' }}
          >
            Loading ...
          </div>
        )}
        {showButton && (
          <Button
            style={{ margin: '8px 0', float: 'right' }}
            color="primary"
            size="sm"
            onClick={loadMore}
          >
            More
          </Button>
        )}
      </div>
    </div>
  );
};

export default ArchivedTickets;
